import React from 'react';
import useResponsive from '../hooks/useResponsive';

const STATS = [
  { num: '15,000+', lbl: 'Students Trained' },
  { num: '50+', lbl: 'Expert Courses' },
  { num: '95%', lbl: 'Placement Rate' },
  { num: '200+', lbl: 'Hiring Partners' },
];

export default function Home({ scrollTo }) {
  const { isMobile, isTablet } = useResponsive();

  const headingSize = isMobile ? 38 : isTablet ? 52 : 66;
  const paddingH = isMobile ? 16 : isTablet ? 24 : 32;

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', textAlign: 'center',
      paddingTop: 66, position: 'relative',
      backgroundImage: 'linear-gradient(rgba(37,99,235,0.05) 1px,transparent 1px),linear-gradient(90deg,rgba(37,99,235,0.05) 1px,transparent 1px)',
      backgroundSize: '56px 56px',
    }}>
      <div style={{ position:'absolute', top:'15%', left:'50%', transform:'translate(-50%,-50%)', width: isMobile?300:700, height: isMobile?250:500, background:'radial-gradient(ellipse,rgba(37,99,235,0.13),transparent 65%)', pointerEvents:'none' }} />
      <div style={{ position:'absolute', bottom:'10%', right:'5%', width: isMobile?180:350, height: isMobile?180:350, background:'radial-gradient(ellipse,rgba(249,115,22,0.09),transparent 65%)', pointerEvents:'none' }} />

      <div style={{ position:'relative', zIndex:2, padding: `70px ${paddingH}px 60px`, maxWidth:820, margin:'0 auto', width: '100%' }}>

        <div style={{ display:'inline-flex', alignItems:'center', gap:8, padding:'7px 18px', borderRadius:99, background:'rgba(255,255,255,0.04)', backdropFilter:'blur(14px)', border:'1px solid rgba(255,255,255,0.07)', fontSize: isMobile?11:12, fontWeight:600, color:'#4ade80', marginBottom:30 }}>
          <span style={{ width:7, height:7, borderRadius:'50%', background:'#4ade80', display:'inline-block', animation:'float 2s ease infinite' }} />
          Admissions Open 2026 — Batch Starting Soon
        </div>

        <h1  style={{ fontFamily:"'Outfit',sans-serif", fontSize: headingSize, fontWeight:900, lineHeight:1.06, letterSpacing: isMobile?1:2, color:'#fff', marginBottom:20 }}>
          Shape Your<br />
          <span style={{ background:'linear-gradient(135deg,#38bdf8,#f97316,#c084fc)', backgroundSize:'300%', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', backgroundClip:'text', animation:'gx 5s ease infinite' }}>
            Global Future
          </span><br />
          With Trinity
        </h1>

        <p style={{ fontFamily:"'DM Sans',sans-serif", fontSize: isMobile?14:17, color:'#64748b', maxWidth:560, margin:'0 auto 38px', lineHeight:1.85 }}>
          India ka premium IT training institute. Mobile App, Full Stack, AI/ML, Cybersecurity aur bahut kuch — real projects ke saath, industry experts se.
        </p>

        <div style={{ display:'flex', gap:14, justifyContent:'center', flexWrap:'wrap', marginBottom:58 }}>
          <button onClick={() => scrollTo('courses')} style={{
            padding: isMobile?'12px 22px':'15px 32px', borderRadius:13,
            background:'linear-gradient(135deg,#2563eb,#1d4ed8)',
            color:'#fff', fontSize: isMobile?14:15, fontWeight:600, border:'none', cursor:'pointer',
            fontFamily:"'DM Sans',sans-serif", transition:'all 0.3s', width: isMobile?'100%':'auto',
          }}
            onMouseEnter={e => { e.currentTarget.style.boxShadow='0 10px 30px rgba(37,99,235,0.4)'; e.currentTarget.style.transform='translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.boxShadow='none'; e.currentTarget.style.transform='none'; }}>
            Explore Courses →
          </button>
          <button onClick={() => scrollTo('about')} style={{
            padding: isMobile?'12px 22px':'15px 32px', borderRadius:13,
            background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.1)',
            color:'#e2e8f0', fontSize: isMobile?14:15, fontWeight:600, cursor:'pointer',
            fontFamily:"'DM Sans',sans-serif", transition:'all 0.3s', width: isMobile?'100%':'auto',
          }}
            onMouseEnter={e => { e.currentTarget.style.background='rgba(255,255,255,0.1)'; e.currentTarget.style.transform='translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.background='rgba(255,255,255,0.05)'; e.currentTarget.style.transform='none'; }}>
            Know More About Us
          </button>
        </div>

        <div style={{ display:'grid', gridTemplateColumns: isMobile?'1fr 1fr':'repeat(4,1fr)', gap: isMobile?10:16 }}>
          {STATS.map(s => (
            <div key={s.lbl} style={{ padding: isMobile?'14px 10px':'18px 30px', borderRadius:16, textAlign:'center', background:'rgba(255,255,255,0.04)', backdropFilter:'blur(14px)', border:'1px solid rgba(255,255,255,0.07)' }}>
              <div style={{ fontFamily:"'Outfit',sans-serif", fontSize: isMobile?20:26, fontWeight:800, color:'#60a5fa', letterSpacing:-1 }}>{s.num}</div>
              <div style={{ fontFamily:"'DM Sans',sans-serif", fontSize: isMobile?9:11, color:'#475569', marginTop:4, fontWeight:500, textTransform:'uppercase', letterSpacing:0.5 }}>{s.lbl}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
